module.exports = __webpack_public_path__ + "img/2-9-7.9108ba28.png";